import '@mlib/index.js';
import '@x3/index.js';

import router from '@simple/router';
import App from './App.vue';
import api from '@simple/api/index.js';

import './config/var.css';

Vue.config.productionTip = false;

Vue.prototype.$api = api;

Vue.prototype.showLoading = (str = '加载中...') => {
  vant.Toast.loading({
    message: str,
    forbidClick: true,
    loadingType: 'spinner',
    overlay: true,
    duration: 0,
  });
};

router.addRoutes(app.x3.side.sideRoutes);

// 为了与后端调试方便
let name = app.tool.parseQuery().name;
if (name) {
  app.http.setHeader('x3-version', name);
}

// 启动应用
function runSystem() {
  new Vue({
    el: '#app',
    router,
    //   store,
    template: '<app/>',
    components: {
      App,
    },
  });
}

// 加载微信sdk并进行config配置
function initWXConfig() {
  let c = {},
    pm0 = app.base.getEnvSDKPromise,
    pm1 = api
      .getWxJsConfig({
        requestUrl: location.href.split('#')[0],
      })
      .then(res => {
        if (res.code == 200) {
          c = res.data;
          return Promise.resolve(c);
        } else {
          return Promise.reject();
        }
      });

  return Promise.all([pm0, pm1]).then(res => {
    app.sdk.setConfig({
      config: {
        debug: false,
        appId: c.appId,
        timestamp: c.timestamp,
        nonceStr: c.nonceStr,
        signature: c.signature,
        openTagList: ['wx-open-launch-weapp'], // 填入打开小程序的开放标签名
      },
      customParams: {
        alertError: false, // 在微信SDK配置失败时，是否给出提示
      },
    });
  });
}

initWXConfig();
runSystem();


// OSS上传相关配置
xgjzt.oss.setConfig({
  max: 2,
  env: process.env.VUE_APP_x3_env,
  getStsParams: api.getOssRequest,
  isEncrypt:true,
  fileNameType:2, // 1原文件名，2随机文件名
});


